import React from 'react';
import PropTypes from 'prop-types'
import Link from '../../Atoms/Link';
import {
    useSourceIdCookie,
} from '../../../utilities/useContentReplacers/contentReplacers/sourceid/useSourceIdCookie';
import replaceSourceId from '../../../utilities/useContentReplacers/contentReplacers/sourceid';

const SourceIdLink = ({ children, href, ...props }) => 
{
    const { sourceid, location } = useSourceIdCookie();

    if (!location) return null;
    return (
        <Link
            {...props}
            href={replaceSourceId(href, { location, sourceid })}
        >
            {children}
        </Link>
    );
};

SourceIdLink.propTypes = {
    /** Content or React Node */
    children: PropTypes.node.isRequired,
    /** URL, if containing sourceid query, will be processed for replacement */
    href: PropTypes.string.isRequired
}

export default SourceIdLink;
